import { Moment } from 'moment';
import { DraggableSlot } from '@modules/timetable';

/**
 * Generate draggable slots based on the supplied number of hours
 * @param hoursForRange
 * @param startTime
 */
export const getDraggableSlots = (hoursForRange: number, startTime: Moment): DraggableSlot[] => {
  return Array.from(Array(hoursForRange)).map((_, index) => {
    return {
      startTime: startTime.clone().add(index / 2, 'h'),
      endTime: startTime.clone().add(index / 2 + 0.5, 'h'),
    };
  });
};
